// src/helpers/contentfulHelper.js
import { createClient } from 'contentful';

const client = createClient({
  space: "us494go8jwv6",
  accessToken: "f174LlwX98UkkNizCl7RHnVLBMAcqOMwWZLCFHTl6oU",
});

export const fetchFooter = async () => {
  try {
    const entries = await client.getEntries({
      content_type: 'footer',
      limit: 1,
    });

    console.log('Footer entries:', entries);  

    return entries.items[0] || null;
  } catch (error) {
    console.error('Error fetching footer:', error);
    return null;
  }
};

export const fetchContactPage = async () => {
  try {
    const entries = await client.getEntries({
      content_type: 'contactPage',
      limit: 1,
    });

    console.log('Contact page entries:', entries);  

    return entries.items[0] || null;
  } catch (error) {
    console.error('Error fetching contact page:', error);
    return null;
  }
};

export const fetchServicesPage = async () => {
  try {
    const entries = await client.getEntries({
      content_type: 'servicesPage',
      limit: 1,
      include: 2,
    });
    console.log('Services page entries:', entries);
    return entries.items[0] || null;
  } catch (error) {
    console.error('Error fetching services page:', error);
    return null;
  }
};

export const fetchServiceBySlug = async (slug) => {
  try {
    const entries = await client.getEntries({
      content_type: 'service',
      'fields.slug': slug,
      limit: 1,
    });

    return entries.items[0] || null;
  } catch (error) {
    console.error('Error fetching service:', error);
    return null;
  }
};

export const fetchGalleryPage = async () => {
  try {
    const res = await client.getEntries({
      content_type: 'galleryPage',
      limit: 1,
      include: 2,
    });

    return res.items[0];
  } catch (err) {
    console.error('Gallery page fetch failed', err);
    return null;
  }
};